let plugin = {
  // 设置本地cookies
  setCookie(key, val) {
    localStorage.setItem(key, JSON.stringify(val))
  },
  // 获取本地cookies
  getCookie(key) {
    return JSON.parse(localStorage.getItem(key)) || {}
  },
  // 时间戳转换为2018-09-22格式
  // 时间戳转换为2018-09-22格式
  formatDateTime(inputTime, format) {
    let times = ''
    if (inputTime) {
      let sjc = inputTime + 8 * 60 * 60 * 1000
      let date = (new Date(sjc).toISOString()) + ''

      date = date.split('-');
      if (format === 'M/D') {
        times = date[1] + '.' + date[2].substr(0, 2)
      } else {

        times = date[0] + '-' + date[1] + '-' + date[2].substr(0, 2);
      }

    }

    return times
  },
  speeds(str) {
    let val = String(str)
    if (val.indexOf('.') > -1) {
      var arr = val.split('.')
      arr[1].substring(0, 1)
      let isPositive = val.indexOf('-') < 0 ? '+' : ''
      return isPositive + arr[0] + '.' + arr[1].substring(0, 1)
    } else {
      let isPositive = val.indexOf('-') < 0 ? '+' : ''
      if (val == -1 || val == 1) {
        return isPositive + val + '.0'
      } else if (val === '0') {
        return val + '.0'
      }
      return isPositive + val
    }
  },
  carry(num) {
    let val = num / 100;

    val = String(val);
    if (val.indexOf('.') > -1) {
      let arr = val.split('.');

      let last = arr[1].substr(0, 2)
      if (last.length <= 1) {
        last = last + '0';
      }
      return arr[0] + '.' + last;
    } else {
      return val + '.00'
    }
  }
}

export default {
  install: function (vm) {
    vm.prototype.$PlugIn = plugin
  }
}


/**
 * 判断是否为空
 */
export function validatenull(val) {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }

  if (val instanceof Array) {
    if (val.length == 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val == 'null' || val == null || val == 'undefined' || val == undefined || val == '') return true
    return false
  }
  return false
}

export function phone(value) {
  const pattern = /^1[3456789]\d{9}$/;
  if (!validatenull(value) && !pattern.test(value)) {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/lib/utils/index.js